import React from 'react'
import { Outlet } from 'react-router-dom'

import { Card, Image, Space } from 'antd-mobile'

import Logo from '../../assets/images/svg/logo.svg'
import './AuthLayout.less'

const AuthLayout = () => {
  return (
    <Card style={{ marginTop: '25%' }}>
      <Space justify='center' block style={{ marginBottom: 64 }}>
        <Image src={Logo} height={40} fit='contain' />
      </Space>
      <Outlet />
    </Card>
  )
}

export default AuthLayout
